import {Injectable} from '@angular/core';
import {ApiService} from "../../../services/api/api.service";
import {Observable} from "rxjs";
import {ReturnDetailInfoDto, ReturnPaymentListDto} from "../models/return.models";
import {UserInfoService} from "../../../services/user-info.service";

@Injectable({
  providedIn: 'root'
})
export class ReturnDataService {

  agentId: string | undefined
  userId: number | undefined

  constructor(
    private apiService: ApiService,
    private userInfoService: UserInfoService
  ) {

    this.userInfoService.userId$.subscribe({
      next: (res) => {
        this.userId = res
      }
    })

    this.userInfoService.agentId$.subscribe({
      next: (res) => {
        this.agentId = res
      }
    })
  }

  loadReturnFilter(): Observable<any> {
    const url = `/agents/${this.agentId}/refunds/filter`
    return this.apiService.httpGet<any>(url)
  }

  loadReturnList(page: number): Observable<ReturnPaymentListDto> {
    const url = `/agents/${this.agentId}/refunds?page_number=${page}&per_page=20`
    return this.apiService.httpPost<ReturnPaymentListDto>(url)
  }

  loadDetailReturn(id: number): Observable<ReturnDetailInfoDto> {
    const url = `/agents/${this.agentId}/refunds/${id}`
    return this.apiService.httpGet<ReturnDetailInfoDto>(url)
  }
}
